import React, { useState } from "react";
import { caseStudiesProcess } from "./CaseStudyData";
import { Col, Container, Row } from "react-bootstrap";
import MajorClient from "../Home/Components/MajorClient";
import Testimonials from "../Home/Components/Testimonials";
import { PiArrowBendDownRightBold } from "react-icons/pi";
import Image1 from "../../Images/CaseStudies/area_app.webp";
import { IoMdStar } from "react-icons/io";
import client from "../../Images/CaseStudies/area_app.webp";

const AreaManagerApp = () => {
  const [tabName, setTabName] = useState("Business Needs");

  return (
    <div>
      <div className="case_study_details case_study">
        <Container>
          <Row className="justify-content-center">
            <Col lg={11} className="case_content text-center">
              <h1>
                <span>Area Manager App</span>
              </h1>
            </Col>
          </Row>
        </Container>
      </div>

      <Container>
        <Row>
          <Col lg={12}>
            <div className="industrial">
              <img src={Image1} alt={Image1} className="img-fluid" />
              <div className="industrial_content">
                <p>
                  A central place for engineers and field staff to manage and monitor agricultural operations across farming areas. It supports area-wise task assignment, measurement-based work tracking, hectare-wise plantation and harvest data, and productivity insights.
                </p>
                <div className="d-flex flex-wrap align-items-center justify-content-between ">
                  <div>
                    <h4>Industry</h4>
                    <p>
                      <b>Agriculture</b>
                    </p>
                  </div>
                  <div>
                    <h4>Country</h4>
                    <p>
                      <b>Germany</b>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      <hr className="m-0" />
      <div className="case_img_box">
        <Container>
          <div className="case_box position-relative">
            <img src={Image1} alt={Image1} />
          </div>
        </Container>
      </div>

      <hr className="m-0" />

      <Container>
        <Row className="case_content_box">
          <Col lg={12} className="px-3">
            <div className="case_content p-3">
              <h2 className="case_heading">About</h2>
              <p>
                {" "}
                Area Manager App is a field and operations management solution for agricultural and site-based teams. It brings together areas, work types (e.g. planting, harvest, irrigation), and tasks so administrators and engineers can plan, assign, and track work and workers can perform and update assigned tasks, all from one place.
                The app uses role-based access and a central dashboard with key metrics, harvest and area analytics, worker timelines, and upcoming tasks. It supports document uploads and maps per area, work diaries linked to tasks and areas, and assignments between areas and workers and between engineers and workers. With support for multiple languages (e.g. English and German), availability as a PWA on phones and tablets, and push notifications to keep teams informed, the solution is designed for multi-farm organisations and helps improve visibility, accountability, and efficiency in the field.
              </p>
            </div>
          </Col>
        </Row>
      </Container>

      <Container className=" my-5">
        <div className="process px-3">
          <h2 className="case_heading">Process</h2>
          <Row className="mt-4 justify-content-center">
            {caseStudiesProcess.map((step, index) => (
              <Col lg={3} md={4} sm={6} key={index} className="mb-3">
                <div className="card">
                  <span>{step.step}</span>
                  {step.icon}
                  <h3>{step.title}</h3>
                  <p>{step.description}</p>
                </div>
              </Col>
            ))}
          </Row>
        </div>
      </Container>

      <Container className=" my-5">
        <Row className="mt-5 client_benefits align-items-center">
          <Col md={6}>
            <h2 className="case_heading">Client Benefits</h2>
            <ul className="mt-4 p-0">
              <li className="d-flex align-items-center gap-2">
                <IoMdStar />
                Single place for areas, work diaries, and tasks
              </li>
              <li className="d-flex align-items-center gap-2">
                <IoMdStar />
                Role-based access control for security and accountability
              </li>
              <li className="d-flex align-items-center gap-2">
                <IoMdStar />
                Dashboard with key metrics and charts
              </li>
              <li className="d-flex align-items-center gap-2">
                <IoMdStar />
                Assignments and clear responsibility
              </li>
              <li className="d-flex align-items-center gap-2">
                <IoMdStar />
                Work diary and activity tracking
              </li>
              <li className="d-flex align-items-center gap-2">
                <IoMdStar />
                Flexible use through the browser or as a PWA on phones and tablets
              </li>
              <li className="d-flex align-items-center gap-2">
                <IoMdStar />
                Multi-language support (English and German)
              </li>
              <li className="d-flex align-items-center gap-2">
                <IoMdStar />
                Central administration
              </li>
            </ul>
          </Col>
          <Col md={6}>
            <img src={client} alt={client} className="img-fluid" />
          </Col>
        </Row>
        <hr className="my-5" />

        <div className="challenges my-5">
          <h2 className="case_heading">Challenges </h2>
          <Row className="mt-4 justify-content-center">
            <Col lg={4} className="border_bottom">
              <div className="card position-relative">
                <span> 1</span>
                <h5> Maintaining Multilingual Support Across Multiple Projects</h5>

                <p className="mb-1">
                  <b>Challenge</b> : The app needed multi-language support and language management directly in it, which made maintenance and reuse across projects difficult. Each new project required repeating translation logic, increasing effort and causing inconsistency.
                </p>

                <p className="mb-1">
                  <b>Solution</b>: We built a separate Python-based translation service and deployed it independently. It centralizes language translation and provides APIs for multiple apps. This separation made translation management easier, reusable across projects, and more consistent.
                </p>
              </div>
            </Col>
            <Col lg={4} className="border-left border_bottom border-right">
              <div className="card position-relative">
                <span> 2</span>
                <h5>Optimizing Dashboard Data Aggregation</h5>

                <p className="mb-1">
                  <b>Challenge</b> :The dashboard required combining multiple data sources such as area statistics, harvest records, tasks, and worker activity. Fetching and aggregating this data efficiently while maintaining a responsive user interface.
                </p>

                <p className="mb-1">
                  <b>Solution</b>: We optimized the data flow by restructuring queries and reducing redundant data fetching. The system aggregates required metrics efficiently before sending them to the frontend, ensuring dashboards load quickly even with large datasets.
                </p>
              </div>
            </Col>
            <Col lg={4} className="border_bottom">
              <div className="card position-relative">
                <span> 3</span>
                <h5>Designing a Scalable Data Model for Operational Workflows</h5>

                <p className="mb-1">
                  <b>Challenge</b>: Tasks, areas, workers, engineers, and work diaries were interrelated. Designing a data model that preserved these relationships while remaining flexible for future features required careful planning.
                </p>

                <p className="mb-1">
                  <b>Solution</b>: We designed normalized data relationships and structured the workflow logic so tasks and work diary entries remained clearly linked to areas and users, ensuring consistency and future scalability.
                </p>
              </div>
            </Col>
          </Row>
        </div>

        <div className="process_tab_box">
          <Row className="justify-content-center">
            <Col lg={10} className="process_tab_list">
              <ul className="p-0">
                <li
                  onClick={() => setTabName("Business Needs")}
                  className={`${tabName === "Business Needs" ? "active" : ""}`}
                >
                  Business Needs
                </li>
                <li
                  onClick={() => setTabName("Objectives Achieved")}
                  className={`${tabName === "Objectives Achieved" ? "active" : ""
                    }`}
                >
                  Objectives Achieved
                </li>
                <li
                  onClick={() => setTabName("Technologies Used")}
                  className={`${tabName === "Technologies Used" ? "active" : ""
                    }`}
                >
                  Technologies Used
                </li>
              </ul>
            </Col>
            <Col lg={10} className="mt-4">
              {tabName === "Business Needs" && (
                <div className="tab_content_box">
                  <div className="box">
                    <ol>
                      <li>
                        <h6>
                          <PiArrowBendDownRightBold />
                          Area Management
                        </h6>
                        <p>
                          A central place to create, edit, view, and activate areas, attach maps and documents, and manage area-level tasks and work diary.
                        </p>
                      </li>
                      <li>
                        <h6>
                          <PiArrowBendDownRightBold />
                          Task and Assignment System
                        </h6>
                        <p>
                          Plan, assign, and track tasks, simple or linked to work types, with clear status and responsibility. Assign workers to areas and users to users.
                        </p>
                      </li>

                      <li>
                        <h6>
                          <PiArrowBendDownRightBold />
                          Dashboard and Reporting
                        </h6>
                        <p>
                          A single view of areas, tasks, workers, harvest quality, area status, planted or harvested or remaining figures, worker timelines, and upcoming tasks.
                        </p>
                      </li>

                      <li>
                        <h6>
                          <PiArrowBendDownRightBold />
                          Administration
                        </h6>
                        <p>
                          Manage work types, users, roles, assignments, notifications, and settings in one place.
                        </p>
                      </li>

                      <li>
                        <h6>
                          <PiArrowBendDownRightBold />
                          Document Management
                        </h6>
                        <p>
                          Secure storage of documents and images in the cloud.
                        </p>
                      </li>

                      <li>
                        <h6>
                          <PiArrowBendDownRightBold />
                          Cross-Platform Use
                        </h6>
                        <p>
                          Use in the browser or as a PWA on Android and iOS for office and field.
                        </p>
                      </li>

                    </ol>
                  </div>
                </div>
              )}

              {tabName === "Objectives Achieved" && (
                <div className="tab_content_box">
                  <div className="box">
                    <ol>
                      <li>
                        <p className="p-0">
                          Clear structure for areas, work types, and tasks with consistent links and traceability
                        </p>
                      </li>
                      <li>
                        <p className="p-0">
                          Role-based access
                        </p>
                      </li>

                      <li>
                        <p className="p-0">
                          Dashboard that stays responsive with user preferences and filters
                        </p>
                      </li>

                      <li>
                        <p className="p-0">
                          Assignments (area-to-worker and user-to-user) with clear ownership and planning
                        </p>
                      </li>
                      <li>
                        <p className="p-0">
                          Work diary tied to areas and work types for audit and compliance
                        </p>
                      </li>
                      <li>
                        <p className="p-0">
                          Secure document and image storage in the cloud
                        </p>
                      </li>
                      <li>
                        <p className="p-0">
                          One app for browser and PWA (Android and iOS) for office and field use
                        </p>
                      </li>
                    </ol>
                  </div>
                </div>
              )}

              {tabName === "Technologies Used" && (
                <div className="tab_content_box">
                  <div className="box">
                    <ol>
                      <li>
                        <p className="p-0 mb-2 mt-0">Angular 18, TypeScript </p>
                      </li>
                      <li>
                        <p className="p-0 mb-2 mt-0">Angular Material, Bootstrap, ng-bootstrap </p>
                      </li>
                      <li>
                        <p className="p-0 mb-2 mt-0">RxJS, ngx-translate</p>
                      </li>
                      <li>
                        <p className="p-0 mb-2 mt-0">ApexCharts, FullCalendar</p>
                      </li>
                      <li>
                        <p className="p-0 mb-2 mt-0">Angular PWA</p>
                      </li>
                      <li>
                        <p className="p-0 mb-2 mt-0">.NET Core</p>
                      </li>
                      <li>
                        <p className="p-0 mb-2 mt-0">SQL Server</p>
                      </li>
                    </ol>
                  </div>
                </div>
              )}
            </Col>
          </Row>
        </div>
      </Container>

      <MajorClient />
      <Testimonials />
      {/* <ContactForm /> */}
    </div>
  );
};

export default AreaManagerApp;
